export default __webpack_public_path__ + "static/6-966ccd29c422d04a36d3711567888777.jpg";